export default __webpack_public_path__ + "a0430c86ba7764bf628effafd2ac51ff.png";